// @ts-nocheck

import {
  Vue, Options
} from 'vue-class-component'
import Header from '@/components/Header.vue'
import { staticFactory } from '@/http/static'
import roleAccessManager from '@/utils/role-access-manager'

@Options({
  components: {
    Header
  },
  data () {
    return {
      student: {},
      billDetails: [],
      userPayments: [],
      months: [],
      totalPaid: 0,
      totalAmount: 0,
      canCreate: false,
      canRead: false,
      canUpdate: false,
      canDelete: false
    }
  },
  methods: {

  },
  async mounted () {
    // Check read access to /user/payment
    if (!roleAccessManager.canRead('/user/payment')) {
      const swal = (await import('sweetalert')).default
      swal('Error', 'Anda tidak memiliki akses ke halaman ini', 'error')
        .then(() => {
          this.$router.push('/loginpage')
        })
      return
    }

    // Set permission flags
    this.canCreate = roleAccessManager.canCreate('/user/payment')
    this.canRead = roleAccessManager.canRead('/user/payment')
    this.canUpdate = roleAccessManager.canUpdate('/user/payment')
    this.canDelete = roleAccessManager.canDelete('/user/payment')

    await Promise.all([
      staticFactory.students(),
      staticFactory.months(),
      staticFactory.userPaymentHistory()
    ]).then(results => {
      this.student = results[0][0],
      this.months = results[1],
      this.userPayments = results[2].reverse()
    })

    this.userPayments.forEach((payment: any) => {
      if (payment.status == 2) this.totalPaid += payment.total_amount
      if (payment.status != 2) this.totalAmount += payment.total_amount
    })
  }
})

export default class UserPayment extends Vue {}
